import join from 'url-join';

import { asyncAction, http } from '../util';

const api = join(import.meta.env.VITE_API_URL, 'v1');

export const createNotification = asyncAction({
  baseName: 'CREATE_NOTIFICATION',
  action: action => payload => dispatch => {
    dispatch(action.start());
    return http
      .post(join(api, 'outage/notification'), payload)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const updateNotification = asyncAction({
  baseName: 'UPDATE_NOTIFICATION',
  action: action => payload => dispatch => {
    dispatch(action.start());
    return http
      .put(join(api, `outage/notification/${payload.id}`), payload)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const deleteNotification = asyncAction({
  baseName: 'DELETE_NOTIFICATION',
  action:
    action =>
    ({ notificationId }) =>
    dispatch => {
      dispatch(action.start());
      return http
        .delete(join(api, `outage/notification/${notificationId}`))
        .then(({ data: response }) => dispatch(action.success(response)))
        .catch(error => dispatch(action.error({ error })));
    }
});

export const fetchNotifications = asyncAction({
  baseName: 'REQUEST_NOTIFICATIONS',
  action: action => () => dispatch => {
    dispatch(action.start());
    return http
      .get(join(api, 'notifications/managable/outages'))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const fetchCustomNotifications = asyncAction({
  baseName: 'REQUEST_CUSTOM_NOTIFICATIONS',
  action: action => () => dispatch => {
    dispatch(action.start());
    return http
      .get(join(api, 'notifications/custom'))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});
